import React from "react"
import "../styles/foot.css"
import swal from "sweetalert"

const Foot = () => {

	return(
		<div className="foot">
			<h3> © On3l7d15h © </h3>
		</div>
	)
}

export default Foot;